import React from 'react';
import { Box } from '@chakra-ui/react';
import StandardModal from '../Modal/StandardModal';
import FindingNotesWrapper from './FindingNotesWrapper';
import SuspenseWrapper from '../SuspenseWrapper/SuspenseWrapper';
import { localise } from '../../../services/lang/lang';
import FindingNotesShareWrapper from './Share/FindingNotesShareWrapper';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import { useUnsavedChanges } from '../UnsavedChanges/UnsavedChangesProvider';
import { useTokens } from '../../../context/TokenProvider';
const FindingNotesModal = ({ onMutated, finding, onClose, canEdit, ...rest }) => {
    const tokens = useTokens();
    const { isShare } = useInspectionDetailContext();
    const { attemptNavigate } = useUnsavedChanges();
    const NotesComponent = isShare
        ? FindingNotesShareWrapper
        : FindingNotesWrapper;
    return (React.createElement(StandardModal, { title: localise('FINDING_NOTES'), onClose: () => attemptNavigate(onClose), ...rest },
        React.createElement(SuspenseWrapper, null,
            React.createElement(Box, { mt: tokens.Spacing06 },
                React.createElement(NotesComponent, { canEdit: canEdit, model: finding, onMutated: onMutated })))));
};
export default FindingNotesModal;
